import { SecurityStatus } from '@shared/enums/security-status';

export class NotificationPanelSecurity {
  clientName!: string;
  securityId!: number;
  entityTypeName!: string;
  securityTypeName!: string;
  investmentJurisdictionName!: string;
  securityStatus!: SecurityStatus;
  lastUpdated!: string;

  get title(): string {
    return `${this.clientName}: ${this.entityTypeName}-${this.securityTypeName}-${this.investmentJurisdictionName}`;
  }
}
